import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { AvForm, AvInput } from 'availity-reactstrap-validation';
import SweetAlert from 'react-bootstrap-sweetalert';
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Label } from 'reactstrap';

import { createPlcSafetyZoneDependency, getPlcSafetyZones } from '../../store/actions';

// P01021-135 (apunte del cliente, "próxima instalación"): una zona puede depender de que otra
// esté también operativa antes de poder reanudar robots — no simétrico (ver design doc). Este
// formulario crea una fila de plc_safety_zone_dependencies: "zoneCode" no reanuda mientras
// "dependsOnZoneCode" siga bloqueada, sea cual sea la causa.
class CreatePlcSafetyZoneDependencyForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      zoneCode: '',
      dependsOnZoneCode: '',
      popup: false,
      pop_msg: null,
      pop_err: null,
    };
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  componentDidMount() {
    this.props.getPlcSafetyZones(this.state.user);
  }

  componentDidUpdate(prevProps) {
    const { messagePlcSafetyZoneDependency, createPlcSafetyZoneDependencyError, loadingCreatePlcSafetyZoneDependency } =
      this.props;
    if (loadingCreatePlcSafetyZoneDependency === false && prevProps.loadingCreatePlcSafetyZoneDependency === true) {
      if (messagePlcSafetyZoneDependency) {
        this.setState({ popup: true, pop_msg: 'Dependencia creada correctamente' });
      } else if (createPlcSafetyZoneDependencyError) {
        this.setState({
          popup: true,
          pop_err: createPlcSafetyZoneDependencyError.message || 'No se ha podido crear la dependencia',
        });
      }
    }
    if ((this.props.zones || []).length > 0 && !this.state.zoneCode) {
      this.setState({ zoneCode: this.props.zones[0].zone_code, dependsOnZoneCode: this.props.zones[0].zone_code });
    }
  }

  confirmPopup() {
    this.setState({ popup: false });
    if (this.state.pop_msg) this.props.history.push('/plcSafetyZoneDependencies');
  }

  handleValidSubmit() {
    const user = this.state.user;
    this.props.createPlcSafetyZoneDependency({
      zone_code: this.state.zoneCode,
      depends_on_zone_code: this.state.dependsOnZoneCode,
      token: user.token,
    });
  }

  render() {
    const zones = this.props.zones || [];
    return (
      <Col lg="12">
        <Card>
          <CardBody>
            <CardTitle className="mb-4">{this.props.t('Crear dependencia entre zonas')}</CardTitle>
            <p className="text-muted">
              {this.props.t(
                'La zona seleccionada primero no podrá reanudar robots mientras la segunda zona siga bloqueada, sea cual sea la causa.',
              )}
            </p>
            <AvForm className="needs-validation" onValidSubmit={this.handleValidSubmit}>
              <Col>
                <FormGroup>
                  <Label htmlFor="zoneDependencyZone">{this.props.t('Zona dependiente (no reanuda sola)')}</Label>
                  <AvInput
                    value={this.state.zoneCode}
                    name="zone_code"
                    type="select"
                    className="form-control"
                    id="zoneDependencyZone"
                    onChange={(e) => this.setState({ zoneCode: e.target.value })}
                  >
                    {zones.map((z) => (
                      <option key={z.zone_code} value={z.zone_code}>
                        {z.zone_name}
                      </option>
                    ))}
                  </AvInput>
                </FormGroup>
              </Col>
              <Col>
                <FormGroup>
                  <Label htmlFor="zoneDependencyDependsOn">{this.props.t('Depende de (debe estar operativa)')}</Label>
                  <AvInput
                    value={this.state.dependsOnZoneCode}
                    name="depends_on_zone_code"
                    type="select"
                    className="form-control"
                    id="zoneDependencyDependsOn"
                    onChange={(e) => this.setState({ dependsOnZoneCode: e.target.value })}
                  >
                    {zones.map((z) => (
                      <option key={z.zone_code} value={z.zone_code}>
                        {z.zone_name}
                      </option>
                    ))}
                  </AvInput>
                </FormGroup>
              </Col>
              <Button color="secondary" type="submit">
                {this.props.t('Crear dependencia')}
              </Button>
            </AvForm>
            {this.state.popup ? (
              <SweetAlert
                type={this.state.pop_msg ? 'success' : 'error'}
                confirmBtnBsStyle={this.state.pop_msg ? 'success' : 'danger'}
                title={this.state.pop_msg ? this.state.pop_msg : this.state.pop_err}
                confirmBtnText={this.props.t('ok')}
                onConfirm={() => this.confirmPopup()}
              ></SweetAlert>
            ) : null}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateprops = (state) => {
  const { createPlcSafetyZoneDependencyError, messagePlcSafetyZoneDependency, loadingCreatePlcSafetyZoneDependency } =
    state.createPlcSafetyZoneDependency;
  const { zones } = state.getPlcSafetyZones;
  return {
    createPlcSafetyZoneDependencyError,
    messagePlcSafetyZoneDependency,
    loadingCreatePlcSafetyZoneDependency,
    zones,
  };
};

export default withRouter(
  connect(mapStateprops, { createPlcSafetyZoneDependency, getPlcSafetyZones })(
    withNamespaces()(CreatePlcSafetyZoneDependencyForm),
  ),
);
